import { Injector } from '@angular/core';

/**
 * Bridge that lets legacy non-DI singletons (e.g. AppCache, which is constructed via a manual
 * `getInstance()` static rather than Angular's constructor injection) resolve real Angular
 * services like LocalStorageService. Set once from AppModule's constructor at bootstrap; safe to
 * read any time after that.
 */
let appInjector: Injector;

export function setAppInjector(injector: Injector): void {
  appInjector = injector;
}

export function getAppInjector(): Injector {
  if (!appInjector) {
    throw new Error('getAppInjector() called before setAppInjector() — AppModule has not finished constructing yet.');
  }
  return appInjector;
}
